/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import type { MouseEvent } from 'react';
import React from 'react';

import { Analytics } from '@trello/atlassian-analytics';
import type { PIIString } from '@trello/privacy';

import { localizeCount } from 'app/scripts/lib/localize-count';
import { naiveShouldComponentUpdate } from 'app/scripts/lib/util/naive-should-component-update';
import { recupWithHelpers } from 'app/scripts/views/internal/recupWithHelpers';

const t = recupWithHelpers('select_member');

interface InviteMemberAutocompleteMultiBoardGuestAlertProps {
  displayOrg:
    | {
        availableLicenseCount?: number | undefined;
        url?: string;
        id?: string;
      }
    | undefined;
  isDesktop: boolean | undefined;
  isWorkspaceAdmin: boolean | undefined;
  workspaceAdmins: PIIString[] | undefined;
}

class InviteMemberAutocompleteMultiBoardGuestAlert extends React.Component<InviteMemberAutocompleteMultiBoardGuestAlertProps> {
  static displayName = 'AutoCompleteMultiBoardGuestAlert';
  static initClass() {
    this.prototype.shouldComponentUpdate = naiveShouldComponentUpdate;

    this.prototype.render = t.renderable(function (
      this: InviteMemberAutocompleteMultiBoardGuestAlert,
    ) {
      const {
        displayOrg,
        isDesktop,
        isWorkspaceAdmin,
        workspaceAdmins,
      } = this.props;

      const owned = displayOrg != null ? isWorkspaceAdmin : undefined;
      const teamUrl = displayOrg != null ? displayOrg.url : undefined;

      return t.div(
        {
          onMouseDown: this.onMouseDown.bind(this),
        },
        () => {
          if (owned && displayOrg && !isDesktop) {
            if ((displayOrg.availableLicenseCount ?? Infinity) > 0) {
              t.format('multi-board-guest-alert-as-admin');
            } else {
              t.format('multi-board-guest-alert-as-admin-no-seats');
            }
          } else if (isDesktop) {
            t.format('multi-board-guest-alert-desktop-2');
          } else {
            if (
              displayOrg != null &&
              workspaceAdmins != null &&
              workspaceAdmins.length > 0
            ) {
              if (workspaceAdmins.length === 1) {
                t.format('multi-board-guest-alert-as-member-with-1-admin', {
                  admin1: workspaceAdmins[0],
                });
              } else if (workspaceAdmins.length === 2) {
                t.format('multi-board-guest-alert-as-member-with-2-admins', {
                  admin1: workspaceAdmins[0],
                  admin2: workspaceAdmins[1],
                });
              } else if (workspaceAdmins.length === 3) {
                t.format('multi-board-guest-alert-as-member-with-3-admins', {
                  admin1: workspaceAdmins[0],
                  admin2: workspaceAdmins[1],
                  admin3: workspaceAdmins[2],
                });
              } else {
                const others = localizeCount(
                  'others',
                  workspaceAdmins.length - 3,
                );
                t.format('multi-board-guest-alert-as-member-with-more-admins', {
                  admin1: workspaceAdmins[0],
                  admin2: workspaceAdmins[1],
                  admin3: workspaceAdmins[2],
                  others,
                  othersUrl: `${teamUrl}/members`,
                });
              }
            } else {
              t.format('multi-board-guest-alert-as-guest');
            }
          }

          if (!isDesktop) {
            t.text(' ');
            const helpUrl =
              'https://help.trello.com/article/1123-multi-board-guests';
            return t.a(
              {
                href: helpUrl,
                target: '_blank',
                onMouseDown(e: MouseEvent<HTMLAnchorElement>) {
                  window.open(helpUrl, '_blank');
                  Analytics.sendClickedLinkEvent({
                    linkName: 'inviteMultiBoardGuestLearnMoreLink',
                    source: 'inviteToBoardInlineDialog',
                    containers: {
                      workspace: {
                        id: displayOrg?.id,
                      },
                    },
                  });
                  e.preventDefault();
                  return e.stopPropagation();
                },
              },
              () => t.format('learn-more'),
            );
          }
        },
      );
    });
  }

  onMouseDown(e: MouseEvent<HTMLAnchorElement>) {
    if (
      (e.target as HTMLAnchorElement).classList.contains('stop-propagation')
    ) {
      e.preventDefault();
      if ((e.target as HTMLAnchorElement).href) {
        return window.open((e.target as HTMLAnchorElement).href, '_blank');
      }
    }
  }
}

InviteMemberAutocompleteMultiBoardGuestAlert.initClass();
export { InviteMemberAutocompleteMultiBoardGuestAlert };
